<eight-cap-card>
    <form
        class="p-24"
        fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto"
        name="form" [formGroup]="form"
    >
        <!-- Email -->
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-12">
            <mat-form-field appearance="outline" fxFlex="0 1 100%">
                <mat-label>{{ 'common.label.email' | translate}}</mat-label>
                <input matInput formControlName="email_override" />
                <mat-error *ngIf="form.get('email_override').hasError('required')">
                    {{'reset_password.email_required' | translate}}
                </mat-error>
                <mat-error *ngIf="form.get('email_override').hasError('email')">
                    {{'forgot_password.validate_email' | translate}}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Password -->
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-12">
            <mat-form-field appearance="outline" fxFlex="0 1 100%">
                <mat-label>{{ 'common.label.password' | translate}}</mat-label>
                <input matInput formControlName="password" />
                <mat-error *ngIf="form.get('password').hasError('required')">
                    {{'common.label.password' | translate}} {{'common.validation.is_required' | translate}}
                </mat-error>
                <mat-error *ngIf="form.get('password').hasError('pattern')">
                    {{'common.validation.password' | translate}}
                </mat-error>
            </mat-form-field>
        </div>

        <div *ngIf="isAdminAllRole" fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-12">
            <div class="mat-form-field-wrapper">
                <mat-checkbox class="pb-20" color="primary" formControlName="is_send_email">
                    {{ 'user.label.is_send_email' | translate}}
                </mat-checkbox>
            </div>
        </div>

        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">
                <mat-icon>save</mat-icon>
                <span class="hide-text">Change</span>
            </button>
        </div>
    </form>
</eight-cap-card>
